import './ChatHistoryExpertMode.styles.scss';

import { observer } from 'mobx-react';
import React, { FC, useEffect, useMemo, useRef } from 'react';

import chatStore from '../../../../store/ChatStore';
import { MessageBox } from '../../../shared/MessageBox/MessageBox';
import { ChatHistoryExpertModeProps } from './ChatHistoryExpertMode.types';

const ChatHistoryExpertMode: FC<ChatHistoryExpertModeProps> = ({ tableId }) => {
  const messagesElementRef = useRef<HTMLDivElement>(null);

  const chatMessages = useMemo(
    () => chatStore.getChatMessages(tableId),
    [chatStore.chatStateChanged, tableId],
  );

  const scrollChatEnd = (): void => {
    if (chatStore.isScrollChatEnd(tableId)) {
      const messagesElement = messagesElementRef.current;
      if (messagesElement) {
        messagesElement.scrollTop = messagesElement.scrollHeight;
      }
    }
  };

  useEffect(() => {
    scrollChatEnd();
    chatStore.markMessagesAsRead(tableId);
  }, [chatMessages.length]);

  return (
    <div
      className="ChatHistoryExpertMode-Component table-section-expert-mode"
      id={`chat-expert-mode-${tableId}`}
    >
      <div className="messages-wrapper p-3" ref={messagesElementRef}>
        {chatMessages.map(message => (
          <MessageBox
            messageId={message.id}
            key={message.id}
            style={{
              background: message.myBot
                ? '#074c2f'
                : 'var(--clubgg-card-background)',
            }}
            message={message}
          />
        ))}
      </div>
    </div>
  );
};

export default observer(ChatHistoryExpertMode);
